module.exports = __webpack_public_path__ + "img/banner.d85d3d4a.png";